const idRoleEmployee = '0a15d8a4-e1a1-4fc1-ba7a-157b34959289';
const idRoleLecturer = '386af797-fdf6-42dc-8bab-d5b42561b5fb';

export { idRoleEmployee, idRoleLecturer };

